import React, { Dispatch, FC, SetStateAction, useState } from 'react';
import { parseCustomerType } from '../../../../utils/CustomerTypes';
import { QuestionnaireForm } from './QuestionnaireForm';
import {
  QuestionnaireAnswers,
  QuestionnaireFormBuilder,
  QuestionnaireFormBuilderProps,
} from '../QuestionnaireFormBuilder';
import { Headline4 } from '../../Text';
import { FlexboxVertical } from '../../Layout';
import { SimpleAccordion } from '../../SimpleAccordion';
import styled from 'styled-components';
import { QuestionnaireWithResultSets } from '../../../../interfaces/Questionnaire';
import { getAddressDisplayName } from '../../../../interfaces/Customer';

const AdditionalQuestionsWrapper = styled(FlexboxVertical)`
  grid-column: span 2;
  
  & > ${Headline4} {
    margin: 3rem 1.5rem 1.5rem;
  }
`;

export type AdditionalQuestionsAnswers = { [key: string]: QuestionnaireAnswers };

interface Props extends Omit<QuestionnaireFormBuilderProps, 'questionnaireId' | 'questions'> {
  questionnaire: QuestionnaireWithResultSets;
  additionalQuestionsAnswersState: [AdditionalQuestionsAnswers, Dispatch<SetStateAction<AdditionalQuestionsAnswers>>];
  onAdditionalValueChanged?: (addressKey: string, questionId: string, value: string | number | boolean, questionnaireId?: string) => void;
  onAdditionalValuePreselected?: (addressKey: string, questionId: string, value: string | number | boolean, questionnaireId?: string) => void;
}
export const QuestionnaireBaseQuestions: FC<Props> = ({ questionnaire, ...props }) => {
  const [openAccordions, setOpenAccordions] = useState<string[]>([]);

  const additionalQuestions = questionnaire?.questionnaire?.additionalQuestions || [];
  const additionalAddresses = props.customer?.additionalAddresses || [];

  return (
    <>
    <QuestionnaireForm title={parseCustomerType(props.customer?.type)}>

      <QuestionnaireFormBuilder
        {...props}
        questionnaireId={questionnaire?.id}
        questions={questionnaire?.questionnaire?.questions}
        address={props.customer?.address}
      />

    </QuestionnaireForm>

    {     // additional questions
      additionalQuestions.length > 0 &&
      <AdditionalQuestionsWrapper>
        <Headline4>Liegenschaftsbezogene Fragen</Headline4>
        {
          additionalAddresses.map((address, index) => {
            const key = `${index}`;
            const state: QuestionnaireAnswers = props.additionalQuestionsAnswersState[0][key] || {};
            const setState: Dispatch<SetStateAction<QuestionnaireAnswers>> = ((nextState: QuestionnaireAnswers) => {
              props.additionalQuestionsAnswersState[1]((prevState) => ({
                ...prevState,
                [key]: nextState,
              }));
            }) as unknown as Dispatch<SetStateAction<QuestionnaireAnswers>>;
            return (
              <SimpleAccordion
                key={index}
                title={getAddressDisplayName(address)}
                collapsed={!openAccordions.includes(key)}
                onClick={(collapsed) => {
                  const next = openAccordions.filter((item) => item !== key);
                  if (collapsed) {
                    next.push(key);
                  }
                  setOpenAccordions(next);
                }}
              >
                <QuestionnaireFormBuilder
                  answersState={[state, setState]}
                  customer={props.customer}
                  address={address}
                  showErrorStates={props.showErrorStates}
                  onValueChanged={(questionId, value, questionnaireId) => {
                    if (props.onAdditionalValueChanged) {
                      props.onAdditionalValueChanged(key, questionId, value, questionnaireId);
                    }
                  }}
                  onValuePreselected={(questionId, value, questionnaireId) => {
                    if (props.onAdditionalValuePreselected) {
                      props.onAdditionalValuePreselected(key, questionId, value, questionnaireId);
                    }
                  }}
                  questionnaireId={questionnaire?.id}
                  questions={questionnaire?.questionnaire?.additionalQuestions}
                />
              </SimpleAccordion>
            );
          })
        }
      </AdditionalQuestionsWrapper>
    }
    </>
  )
}
